export default __webpack_public_path__ + "static/media/typeperson.eed16a34.svg";